import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { SavedJobPost } from "@/types/user";
import { JobPost } from "@/types/jobPost";

export interface UpdateSavedJobViewCountData {
  saved_job_id: SavedJobPost["id"];
}

export interface UpdateSavedJobViewCountResponse {
  success: boolean;
  message: string;
  saved_job: {
    id: SavedJobPost["id"];
    job_title: JobPost["job_title"];
    view_count: SavedJobPost["view_count"];
    last_viewed_at: SavedJobPost["last_viewed_at"];
    application_status: SavedJobPost["application_status"];
  };
}

export const useUpdateSavedJobViewCount = () => {
  const [data, setData] = useState<UpdateSavedJobViewCountResponse | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const updateSavedJobViewCount = async (
    formData: UpdateSavedJobViewCountData,
  ) => {
    setLoading(true);
    setError(null);

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response =
        await axiosInstance.post<UpdateSavedJobViewCountResponse>(
          "users/users/update_saved_job_count/",
          formData,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          },
        );
      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, updateSavedJobViewCount };
};
